export const getDataField = (key) => {
  if (key === 'third_party_investments') return 'investments_out_of_xp'
  if (key === 'terms_agreement' || key === 'address' || key === 'external_activities') 
    return 'answer'
  
  return 'items'
}

export const DATA_FIELDS_NAMES = {
  address: 'Endereço residencial',
  social_networks: '1. Redes Sociais',
  financial_activities: '2. Distribuição de valores mobiliários',
  environment_related_activities: '3. Atividades de natureza ambiental',
  external_activities: '4. Vínculos Empregatícios',
  national_product_offering_activities: '5. Produtos Financeiros nacionais',
  international_product_offering_activities:
    '6. Produtos Financeiros internacionais',
  representation_activities:
    '7. Representação ou governança em entidades financeiras',
  automation_activities: '8. Robôs de investimento',
  kinship_xp: '9. Relações de parentesco na XP Inc.',
  pep_relationship: '10. Pessoa Exposta Politicamente',
  attorney_activities: '11. Procurador em investimentos',
  third_party_investments: '12. Investimentos fora da XP Inc.',
  court_lawsuit_cvm_bacen_sfn: '13. Punições em orgãos reguladores',
  environmental_court_lawsuit: '14. Processos de natureza ambiental',
  criminal_court_lawsuit: '15. Processos de natureza criminal',
  negative_media: '16. Mídia Negativa',
  restrictive_list: '17. Listas Restritivas',
  relation_with_another_companies: '18. Prestação de serviços',
  terms_agreement: '19. Aceite dos termos de associação do parceiro XP',
}
